<template>
  <div id="app" :style="{backgroundColor:custombgcolor?custombgcolor:'#FFFFFF'}">
  <!-- <div id="app"> -->
		<NavBar
			v-isWeChatBrowser
			v-show="!showTab"
			@click-left="cancelFillModal"
			style="background:#F39200"
		>
			<template #title>
				<span style="color:#FFFF;">{{title}}</span>
			</template>
			<template #left>
				<van-icon name="wap-home" color="#FFFFFF" size="20px" />
			</template>
		</NavBar>
    
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <van-dialog
      show-cancel-button
      v-model="showFill"
      @cancel="cancelFillModal"
      @confirm="goFillInfo"
    >
      <div class="dialog-header">温馨提示</div>
      <div class="dialog-body">
        <img style="width:2.47rem;height:2.26rem;" src="~assets/img/sports/fill.png" />
        <br />
        <span>
          为了更好的参赛体验
          <br />请您完善相关信息
        </span>
      </div>
    </van-dialog>

    <Tabbar
      v-show="showTab"
      @change="onChangeTab"
      v-model="activeTab"
      v-isWeChatBrowser
      style="background:#F39200;"
      class="footer"
    >
      <TabbarItem>
        <img src="~assets/img/sports/indexa.svg" alt v-if="activeTab==0" />
        <img src="~assets/img/sports/index.svg" alt v-else />
      </TabbarItem>
      <TabbarItem>
        <img src="~assets/img/sports/mya.svg" alt v-if="activeTab==1" />
        <img src="~assets/img/sports/my.svg" alt v-else />
      </TabbarItem>
    </Tabbar>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Tabbar, TabbarItem, NavBar } from "vant";
export default {
  components: {
    Tabbar,
    TabbarItem,
    NavBar,
  },
  watch: {
    $route(newvalue, oldvalue) {
      this.handleTabbarShow();
      this.title = newvalue.meta.title;
    },
  },
  computed: {
    ...mapState({
      showSpin: (state) => state.app.showSpin,
      custombgcolor: (state) => state.app.custombgcolor,
    }),
    showFill: {
      get() {
        return this.$store.state.app.showFill;
      },
      set(val) {
        this.$store.commit("toggleShowFill", val);
      },
    },
  },
  data() {
    return {
      title: "",
      activeTab: 0,
      showTab: true,
			
			isshow: true,
			
    };
  },
  methods: {
    goFillInfo() {
      this.$router.push({ name: "UserEdit" });
    },
    handleTabbarShow() {
      this.$storage.get("home").then((res) => {
        if (!!res && this.$route.name == res.name) {
          this.activeTab = 0;
          this.showTab = true;
        } else if (this.$route.name == "UserHome") {
          this.activeTab = 1;
          this.showTab = true;
        } else {
          this.showTab = false;
        }
      });
    },
    cancelFillModal() {
      this.showFill = false;
      this.$storage.get("home").then(
        (router) => {
          if (router) {
            this.$router.push(router);
          } else {
            this.$router.push({ name: "index" });
          }
        },
        () => {
          this.$router.push({ name: "index" });
        }
      );
    },
    onChangeTab: function (e) {
      switch (+e) {
        case 0:
          this.$storage.get("home").then(
            (router) => {
              if (router) {
                this.$router.push(router);
              } else {
                this.$router.push({ name: "index" });
              }
            },
            () => {
              this.$router.push({ name: "index" });
            }
          );
          break;
        case 1:
          this.$router.push({ name: "UserHome" });
          break;
      }
    },
  },
	created(){
		// console.log("666666", this.$route)
		
	},
  mounted() {
		if(this.$route.name == 'grades' || this.$route.name == 'rank'){
			this.isshow = false
		}
    this.handleTabbarShow();
		
  },
};
</script>
<style lang="less">
@import "./App.less";
</style>
<style lang="less" scoped>
.footer {
  img {
    width: 1.8rem;
    height: 0.71rem;
  }
}
.dialog-header {
  height: 1.25rem;
  background-image: url("~assets/img/sports/dialog_header.png");
  background-size: 100% 100%;
  line-height: 1.25rem;
  text-align: center;
  color: #ffffff;
  font-size: large;
  font-weight: bold;
}
.dialog-body {
  text-align: center;
  margin: 0.3rem 0 0.5rem;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/deep/.van-dialog__content {
  text-align: center;
}
</style>
